if (!customElements.get("ugc-slider")) {
	customElements.define(
		"ugc-slider",
		class UgcSlider extends HTMLElement {
			constructor() {
				super()

				this.slider = this.querySelector(".ugc-slider__slider")
				if (this.slider) {
					this.initSlider()
				}
			}

			initSlider() {
				var dt_offset = this.calcDesktopOffset()
				let slider = new Swiper(this.slider, {
					slidesPerView: 1.3,
					slidesOffsetBefore: 15,
					slidesOffsetAfter: 15,
					spaceBetween: 15,
					speed: 400,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					breakpoints: {
						768: {
							spaceBetween: 24,
							slidesPerView: 4,
							slidesOffsetBefore: dt_offset,
							slidesOffsetAfter: dt_offset,
						},
					},
					mousewheel: {
						forceToAxis: true,
					},
				})
			}

			calcDesktopOffset() {
				//swiper slider only accepts int for offsett, page-width uses min-width
				//return calulated offest value

				//get screen width for js offset
				var screen_width = document.body.offsetWidth // have to use body here are width is large with un-init sliders excaping container
				const max_width = 1600
				const padding = 50

				var offset = screen_width < max_width ? padding : (screen_width - max_width) / 2 + 50

				return offset
			}
		}
	)
}
